import { css } from '@sitebase/emotion';
import { rgba } from 'polished';
import { colorMonochromeBlack, fontDefaults } from '../settings';

// eslint-disable-next-line import/prefer-default-export
export var overlay = /*#__PURE__*/css(fontDefaults, ';align-items:center;background-color:', rgba(colorMonochromeBlack, 0.6), ';bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;');